module.exports = __webpack_public_path__ + "img/reserve-active.2091fd76.png";